/** Nom d'une page vue : titre du contenu, chemin dessous, lien vers la page. */
import { cn } from '@jeraisonne/ui';
import { pageHref, pageLabel } from '@/lib/admin/live-stats';

const SITE_ORIGIN =
  (import.meta.env.VITE_MARKETING_URL as string | undefined) ?? 'https://jeraisonne.fr';

export function PageName({
  app,
  path,
  label,
}: {
  app: 'site' | 'app';
  path: string;
  label?: string | null;
}) {
  const name = pageLabel(path, label);
  const href = pageHref(app, path, SITE_ORIGIN);
  const titled = name !== path && name !== 'Accueil';
  const main = (
    <span
      className={cn(
        'text-ink-800 block truncate',
        titled ? 'font-sans text-sm' : 'font-mono text-xs',
      )}
    >
      {name}
    </span>
  );
  return (
    <span className="min-w-0" title={path}>
      {href ? (
        <a
          href={href}
          target="_blank"
          rel="noreferrer"
          className="hover:text-primary-600 block hover:underline"
        >
          {main}
        </a>
      ) : (
        main
      )}
      {titled && <span className="text-ink-400 block truncate font-mono text-xs">{path}</span>}
    </span>
  );
}
